import React from 'react';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import Input from '../../forms/Input';
import Form from '../../forms/Form';
import Checkbox from '../../forms/Checkbox';
import Button from '../../forms/Button';
import Table, { Ctd } from '../../table/Table';
import { generateId } from '../../utility/functions';
import GetState from '../../GetState';
import ManagementRow from '../../table/ManagementRow';
import { userRoles } from '../../RoleProtected';
import ModalFactory from '../../Modal';
import CheckMark from '../../CheckMark';

const TaxRates = ({ ...props }) => {

    const [taxRates, refreshTaxes] = GetState(QuestRoute.taxesRates.taxes)

    const TaxForm = ({ values, ...props }) => {
        return (
            <>
                <Input
                    label='Name'
                    name='description'
                    required
                />
                <Input
                    label='Tax Rate'
                    name='taxRateValue'
                    type='number'
                    min={0.01}
                    max={100.00}
                    step={0.01}
                    required
                />
                <Checkbox
                    label='Is Compound'
                    name='isCompound'
                />
            </>
        )
    }

    const deleteTaxRate = (tax) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete ${tax.description}?`,
                type: 'warning',
            },
            promise: {
                title: 'Deleting Product',
                body: `Deleting ${tax.description}`,
                callback: () => HamQuest.delete(QuestRoute.taxesRates.edit(tax.taxRateId))
            },
            confirmed: {
                title: 'Success',
                body: `${tax.description} successfully deleted.`,
                type: 'success'
            },
            finally: () => refreshTaxes()
        })
    }

    const addTaxRate = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Add Tax`,
            body: (
                <Form
                    inputs={{
                        description: '',
                        taxRateValue: '',
                        isCompound: ''
                    }}
                    onSubmit={e => (
                        HamQuest.post(QuestRoute.taxesRates.taxes, { ...e })
                            .then(() => {
                                ModalFactory.close(id);
                                refreshTaxes();
                            })
                    )}
                    text='Add Tax'
                >
                    {({ values }) => <TaxForm values={values} />}
                </Form>
            )
        })
    }

    const editTaxRate = (tax) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Edit ${tax.description}`,
            body: (
                <Form
                    inputs={{ ...tax }}
                    onSubmit={e => (
                        HamQuest.put(QuestRoute.taxesRates.edit(tax.taxRateId), { ...e })
                            .then(() => {
                                ModalFactory.close(id);
                                refreshTaxes();
                            })
                    )}
                    text='Update'
                >
                    {({ values }) => <TaxForm values={values} />}
                </Form>
            )
        })
    }

    const locationsTableConfig = {
        label: 'Tax Rates',
        data: taxRates,
        controls: [<Button roles={userRoles.admin} onClick={addTaxRate}>Add Tax Rate</Button>],
        headers: [
            {
                label: 'Name',
                propKey: 'description',
            }, {
                label: 'Rate',
                propKey: 'taxRateValue',
            }, {
                label: 'Is Compound',
                propKey: 'isCompound',
                options: true
            },
        ],
        renderFormat: (e, index, data) => (
            <ManagementRow
                key={generateId()}
                controls={[
                    <Button onClick={() => editTaxRate(e, data)} key={generateId()} >Edit</Button>,
                    <Button onClick={() => deleteTaxRate(e, data)} key={generateId()} >Delete</Button>
                ]}
            >
                <td>{e.description}</td>
                <td>{e.taxRateValue}%</td>
                <Ctd><CheckMark checked={e.isCompound} /></Ctd>
            </ManagementRow>
        )
    }

    return (<Table config={locationsTableConfig} />);
}

export default TaxRates;